/**
 * Truncates a number toward zero to an integer.
 *
 * Uses double bitwise NOT (~~) which is faster than Math.trunc()
 * and equivalent for numbers within 32-bit integer range.
 * Unlike Math.floor(), this truncates toward zero for negative
 * numbers (e.g., ~~(-5.7) = -5, not -6).
 *
 * @param {number} value
 * @returns {number}
 */
export function truncateToInteger(value) {
    return ~~value
}
